import React, { useState, useContext, useEffect } from 'react';
import {
	TextField,
	Container,
	Button,
	Paper,
	Typography,
	MenuItem,
	InputLabel,
	FormControl,
	Select,
	Switch,
	FormControlLabel,
	Checkbox,
	Divider
} from '@mui/material';
import { Stack } from '@mui/system';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSave, faChevronCircleLeft } from '@fortawesome/free-solid-svg-icons';

import { useNavigate } from 'react-router-dom';
import { DataContext } from '../../../context/DataContext';
import { getRuta, simpleMessage } from '../../../helpers/Helpers';
import { deleteToken, deleteUserData, getToken } from '../../../api/Account';
import { addRolAsync, getRolListAsync } from '../../../api/Rols';

const MODULES = {
	Clientes: [
		{ description: 'CLIENTS VER', label: 'Ver Clientes' },
		{ description: 'CLIENTS CREATE', label: 'Crear Clientes' },
		{ description: 'CLIENTS UPDATE', label: 'Actualizar Clientes' },
		{ description: 'CLIENTS DELETE', label: 'Eliminar Clientes' }
	],
	Creditos: [
		{ description: 'CREDITS VER', label: 'Ver Creditos' },
		{ description: 'CREDITS CREATE', label: 'Crear Creditos' },
		{ description: 'CREDITS UPDATE', label: 'Actualizar Creditos' },
		{ description: 'CREDITS DELETE', label: 'Eliminar Creditos' },
		{ description: 'CREDIT LIQUIDATE', label: 'Liquidar Creditos' },
		{ description: 'PAYMENT UPDATE', label: 'Actualizar Plan de Pagos' },
		{ description: 'PRINT PAGARE', label: 'Imprimir Pagaré' },
		{ description: 'CREDITNOTE', label: 'Nota de Crédito' },
		{ description: 'CHANGE GESTOR', label: 'Cambiar Gestor' },
		{ description: 'CREDITS REGEN', label: 'Regenerar Créditos' },
		{ description: 'EDIT FECHA CUOTA', label: 'Editar Fecha de Cuota' },
		{ description: 'ADD NOTA VISITA', label: 'Agregar Nota de Visita' },
		{ description: 'NOTA VISITA VER', label: 'Ver Nota de Visita' },
		{ description: 'CHANGE FORMA PAGO', label: 'Cambiar Forma de Pago' }
	],
	Administración: [
		{ description: 'CASHMOV VER', label: 'Ver Caja' },
		{ description: 'CASHMOV CREATE', label: 'Crear Movimiento' },
		{ description: 'CASHMOV DELETE', label: 'Eliminar Movimiento' },
		{ description: 'ADMON VER', label: 'Ver Administración' },
		{ description: 'ADMON CREATE', label: 'Crear Administración' },
		{ description: 'CAJA VER', label: 'Ver Caja' },
		{ description: 'CAJA CREATE', label: 'Crear Caja' },
		{ description: 'ACAJA CREATE', label: 'Crear Arqueo de Caja' },
		{ description: 'ACAJA VER', label: 'Ver Arqueo de Caja' },
		{ description: 'LIBDIARIO UPDATE', label: 'Actualizar Libro Diario' }
	],

	RRHH: [
		{ description: 'NOMINA CREAR', label: 'Crear Nómina' },
		{ description: 'NOMINA VER', label: 'Ver Nómina' },
		{ description: 'NOMINA UPDATE', label: 'Actualizar Nómina' },
		{ description: 'NOMINA DELETE', label: 'Anular Nómina' },
		{ description: 'CHANGE CONTRACT TYPE', label: 'Cambiar Tipo de Contrato' }
	],
	Reportes: [
		{ description: 'REPORTS VER', label: 'Ver Reportes' },
		{ description: 'RCLIENTS', label: 'Clientes por Gestor' },
		{ description: 'RCREDXGEST', label: 'Créditos por Gestor' },
		{ description: 'RCOBDIARIO', label: 'Cobro Diario' },
		{ description: 'RECUPERAC', label: 'Recuperación' },
		{ description: 'RDESEMBOLSO', label: 'Desembolso' },
		{ description: 'RSALCART', label: 'Saldos Cartera' },
		{ description: 'RCREDVENC', label: 'Créditos Vencidos' },
		{ description: 'RVENCPROY', label: 'Vendimientos Proyectados' },
		{ description: 'RCREDCANC', label: 'Créditos Cancelados' },
		{ description: 'RACCOUNTSTS', label: 'Estado de Cuenta' },
		{ description: 'RBOXCLOSE', label: 'Cierre de Caja' },
		{ description: 'RCARTERACREDIT', label: 'Créditos de Cartera' },
		{ description: 'RCREDSANEADOS', label: 'Créditos Saneados' },
		{ description: 'RCIERRE', label: 'Reporte de Cierre' },
		{ description: 'REP UTRACK', label: 'Rastreo de Usuarios' },
		{ description: 'RVARCAPITAL', label: 'Variación de Capital' },
		{ description: 'RNOTAVISITA', label: 'Notas de Visita' }
	],
	'Reportes Administrativos': [
		{ description: 'REP HGASTO', label: 'Reporte de Gastos' },
		{ description: 'CASHFLOW', label: 'Flujo de Caja' },
		{ description: 'REP HLDIADIO', label: 'Libro Diario' },
		{ description: 'REP BALC', label: 'Balanza de Comprobación' },
		{ description: 'REP ERESULT', label: 'Estado de Resultados' },
		{ description: 'REP BALGRAL', label: 'Balance General' },
		{ description: 'GET SIN RIESGO', label: 'Ver Reporte Sin Riesgo' }
	],

	Seguridad: [
		{ description: 'SECURITY VER', label: 'Ver Usuarios y Roles' },
		{ description: 'SECURITY CREATE', label: 'Crear Usuarios y Roles' },
		{ description: 'SECURITY UPDATE', label: 'Actualizar Usuarios y Roles' },
		{ description: 'SECURITY DELETE', label: 'Eliminar Usuarios y Roles' },
		{ description: 'VER HORARIOS', label: 'Ver Horarios' },
		{ description: 'EDITAR HORARIOS', label: 'Editar Horarios' },
		{ description: 'VER SUCURSAL', label: 'Ver Sucursal' },
		{ description: 'CREAR SUCURSAL', label: 'Crear Sucursal' },
		{ description: 'EDITAR SUCURSAL', label: 'Editar Sucursal' },
		{ description: 'MIGRAR CARTERA', label: 'Migrar Cartera' }
	],
	Configuración: [
		{ description: 'CONFIG VER', label: 'Ver Configuraciones' },
		{ description: 'CONFIG CREATE', label: 'Crear Configuraciones' },
		{ description: 'CONFIG UPDATE', label: 'Actualizar Configuraciones' },
		{ description: 'CONFIG DELETE', label: 'Eliminar Configuraciones' }
	]
};

const AddRol = () => {
	const token = getToken();
	let ruta = getRuta();
	let navigate = useNavigate();

	const { setIsLoading, setIsLogged, setIsUnautorized } = useContext(DataContext);

	const [rolName, setRolName] = useState('');
	const [isFullAccess, setIsFullAccess] = useState(false);
	const [rolesList, setRolesList] = useState([]);

	const [nivelJerarquico, setNivelJerarquico] = useState(0);

	const [permissions, setPermissions] = useState(
		Object.fromEntries(
			Object.values(MODULES)
				.flat()
				.map(({ description }) => [description, false])
		)
	);

	const handleChangeFullAccess = () => {
		setIsFullAccess((prev) => {
			const newValue = !prev;
			setPermissions((prevPermissions) =>
				Object.fromEntries(Object.keys(prevPermissions).map((p) => [p, newValue]))
			);
			return newValue;
		});
	};

	const saveRol = async () => {
		if (!rolName.trim()) {
			simpleMessage('Ingrese un nombre para el nuevo rol', 'error');
			return;
		}
		if (nivelJerarquico === '') {
			simpleMessage('Seleccione un rol superior', 'error');
			return;
		}

		const datos = {
			roleName: rolName.trim(),
			isFullAccess,
			nivelJerarquico,
			permissions: Object.entries(permissions).map(([description, IsEnable]) => ({
				description,
				IsEnable
			}))
		};

		setIsLoading(true);
		const result = await addRolAsync(token, datos);
		if (!result.statusResponse) {
			setIsLoading(false);
			if (result.error === 'eX01') {
				deleteUserData();
				deleteToken();
				setIsLogged(false);
				return;
			}

			if (result.error === 'Unauthorized') {
				setIsUnautorized(true);
				return;
			}

			simpleMessage(result.error, 'error');
			return;
		}
		setIsLoading(false);
		clearData();
		simpleMessage('Rol Agregado...!', 'success');
	};

	useEffect(() => {
		(async () => {
			setIsLoading(true);
			const result = await getRolListAsync(token);
			if (!result.statusResponse) {
				setIsLoading(false);
				if (result.error === 'Unauthorized') {
					setIsUnautorized(true);
					return;
				}
				simpleMessage(result.error, 'error');
				return;
			}

			setRolesList(result.data.result || []);
			setIsLoading(false);
		})();
	}, []);

	const clearData = () => {
		setRolName('');
		setNivelJerarquico('');
		setIsFullAccess(false);
		setPermissions(Object.fromEntries(Object.keys(permissions).map((p) => [p, false])));
	};

	return (
		<div>
			<Container maxWidth="xl">
				<Paper
					style={{
						padding: 20
					}}
				>
					<Stack direction={{ xs: 'column', sm: 'row' }} alignItems="center" spacing={1}>
						<Button
							onClick={() => {
								navigate(`${ruta}/rols`);
							}}
							style={{
								color: '#2979ff',
								borderColor: '#2979ff'
							}}
							variant="outlined"
						>
							<FontAwesomeIcon
								style={{ marginRight: 10, fontSize: 20 }}
								icon={faChevronCircleLeft}
							/>
							Regresar
						</Button>

						<Typography color={'#00a152'} variant="h4" fontWeight={'bold'}>
							Agregar Rol
						</Typography>
					</Stack>

					<hr />

					<Typography variant="h6" color={'#1c54b2'} style={{ textAlign: 'left' }}>
						Configuraciones del Nuevo Rol
					</Typography>

					<Paper
						style={{
							padding: 20,
							textAlign: 'center'
						}}
					>
						<Stack
							spacing={2}
							direction={{ xs: 'column', sm: 'row' }}
							justifyContent="space-between"
						>
							<TextField
								fullWidth
								style={{ maxWidth: 600 }}
								onChange={(e) => setRolName(e.target.value.toUpperCase())}
								label={'Nombre rol'}
								value={rolName}
							/>

							<FormControl fullWidth required style={{ maxWidth: 600 }}>
								<InputLabel id="demo-simple-select-standard-label">
									Seleccione un rol superior
								</InputLabel>
								<Select
									labelId="demo-simple-select-standard-label"
									id="demo-simple-select-standard"
									value={nivelJerarquico}
									onChange={(e) => setNivelJerarquico(e.target.value)}
									label="Seleccione un rol superior"
									style={{ textAlign: 'left' }}
								>
									<MenuItem value="">
										<em>Seleccione un rol superior</em>
									</MenuItem>
									{rolesList.map((item) => {
										return (
											<MenuItem key={item.id} value={item.id}>
												{item.rolName}
											</MenuItem>
										);
									})}
								</Select>
							</FormControl>
						</Stack>

						<Stack
							spacing={2}
							direction="row"
							alignItems="center"
							justifyContent="center"
						>
							<Typography
								fontWeight={'bold'}
								style={{
									color: '#2979ff',
									textAlign: 'center'
								}}
							>
								Acceso Total al Sistema
							</Typography>

							<FormControlLabel
								control={
									<Switch
										checked={isFullAccess}
										onChange={handleChangeFullAccess}
									/>
								}
								label={isFullAccess ? 'Activado' : 'Desactivado'}
								sx={{ alignSelf: 'center' }}
							/>
						</Stack>

						{Object.entries(MODULES).map(([modName, perms]) => (
							<Paper key={modName} sx={{ p: 2, mt: 2 }}>
								<Typography
									variant="h6"
									color="#2196f3"
									fontWeight="bold"
									textAlign="center"
								>
									{`Módulo ${modName}`}
								</Typography>

								<Divider sx={{ my: 1 }} />

								<Stack
									direction={{ xs: 'column', sm: 'row' }}
									justifyContent="space-around"
									alignItems="center"
									spacing={2}
									flexWrap="wrap"
								>
									{perms.map(({ description, label }) => (
										<FormControlLabel
											key={description}
											control={
												<Checkbox
													checked={permissions[description]}
													onChange={() =>
														setPermissions((prev) => ({
															...prev,
															[description]: !prev[description]
														}))
													}
													// size="large"
												/>
											}
											label={label}
											labelPlacement="top"
										/>
									))}
								</Stack>
							</Paper>
						))}

						<Button
							variant="contained"
							sx={{ alignSelf: 'center', mt: 2, bgcolor: '#2979ff' }}
							startIcon={<FontAwesomeIcon icon={faSave} />}
							onClick={saveRol}
						>
							Guardar Rol
						</Button>
					</Paper>
				</Paper>
			</Container>
		</div>
	);
};

export default AddRol;
